import {
  generateUID,
} from './../../_util.js';

import Cookie from 'js-cookie';

/** Class representing a ViewConstructor */
export class ViewConstructor {
  /**
  All components are built off of this view.
  This extension offers
  - toggle of loading class
  - callback functions for manipulating css of containers

  Parameters
  mountId - where element will mount
  */
  constructor(configObject) {
    this.mountPoint = document.getElementById(configObject.mountId);
    this.state = {
      generatedId: `view-id-${ generateUID() }`,
      isLoading: false,
    };

    this.updateState(configObject);

    this.addElement();

    this.cookie = Cookie;

    this.componentDidMount();
    this.enabled = false;
  }

  /** 
  Updates state
  - refactor oportunity: move this method into the ViewConstructor and let all views handle their own state.
  */
  updateState(newState) {
    this.state = Object.assign({}, this.state, newState);
  }

  /**
  Fired when component mounts and is added to screen.
  */
  componentDidMount() {
    
  }

  /**
  # addElement
  appends data to DOM

  This method generates the reference ID
  */
  addElement(data) {
    // Adding to screen does not mean it is visible
    
    this.mountPoint.innerHTML += this.generateTemplate(data);
    this.$ref = $(`#${ this.state.generatedId }`);
  }

  /**
  # generateTemplate
  used by addElement. 
  This wraps the div that is manipulated on/off the dom 
  */
  generateTemplate(data) {
    return `
      <div id="${ this.state.generatedId }" class="view" style="transform: translate3d(-100%, -100%, 0); opacity: 0;">
        <div class="view__wrapper">
          ${ this.render(data) }
        </div>
      </div>
    `;
  }

  /**
  toggleLoading
  - toggles current state of loading class
  */
  toggleLoading(forceLoading) {
    // grab reference to node element
    let $ref = $(`#${ this.state.generatedId }`);

    // if the developer has not passed in a forced argument, check just toggle it
    if (forceLoading === undefined) {
      if (this.state.isLoading) {
        $ref.show();
        $ref.removeClass('view__loading');
      } else {
        $ref.hide();
        $ref.addClass('view__loading');
      }

      this.updateState({
        isLoading: !this.state.isLoading,
      });

    } else {

      if (forceLoading === false) {
        // the developer forces it off
        $ref.show();
        $ref.removeClass('view__loading');
        this.updateState({
          isLoading: false,
        });
      } else {
        // the developer forces it on
        $ref.hide();
        $ref.addClass('view__loading');
        this.updateState({
          isLoading: true,
        });
      }
    }

    if (this.state.isLoading) {
      $('.loading').css({
        display: 'flex',
        opacity: 1,
      });
    } else {
      $('.loading').css({
        opacity: 0,
        display: 'none',
      });
    }
  }

  /**
  removeElement
  This will destroy the container that is generated when
  */
  removeElement() {
    this.$ref.remove();
  }

  
  /**
    enterScreen
    here's where the css entering screen or leaving screen exists
    returns this.$ref which is a reference to the element
  */
  enterScreen(cb) {
    let $ref = $(`#${ this.state.generatedId }`);
    
    if(typeof cb === 'function') {
      cb($ref);
    } else {
      $ref.css({
        'transform': `translate3d(0, 0, 0)`,
        'opacity': '1',
        'z-index': 2,
        'pointer-events': 'auto',
        'height': 'auto',
        'overflow': 'visible',
      });
    }

    this.componentDidEnter();
  }
  componentDidEnter() {
    this.enabled = true;
  }

  /**
  cloneConsultationButton

  Looks for consultation button that needs to be clone for landing page and appends it to button container within this view.

  @returns cloned button
  */
  cloneConsultationButton() {
    let $ref = $(`#${ this.state.generatedId }`);

    let button = $('.btn-for-gallery.fancyconsultation').clone(true);

    button.removeClass('btn-for-gallery');
    
    return button;
  }
  
  /**
  leaveScreen
    function to call when you want the component to leave the screen
  */
  leaveScreen(cb) {
    let $ref = $(`#${ this.state.generatedId }`);

    if (typeof cb === 'function') {
      cb($ref);
    } else {
      $ref.css({
        transform: `translate3d(-100%, -100%, 0)` ,
        opacity: 0,
        'z-index': -1,
        'pointer-events': 'none',
        'height': '0',
        'overflow': 'hidden',
      });
    }
    this.componentDidLeave();
  }
  /**
   * componentDidLeave
   * Useful for unbinding event listeners
   */
  componentDidLeave() {
    this.enabled = false;
  }

  /**
  @param {string} meta title for current view
  @param {string} meta description for current view

  Updates both the meta title and meta description tags.
  Also updates og meta title and description tags.
  */
  updateMeta(title, description) {
    if (title !== undefined && typeof title === 'string') {
      $('title').text(title);

      var ogMetaTitle = $('meta[property="og:title"]');
      if (ogMetaTitle.length > 0) {
        ogMetaTitle.attr('content', title);
      }
    }

    if (description !== undefined && typeof description === 'string') {
      if($('meta[name="description"]').length < 1)
        $('title').after('<meta name="description" content="">');

      $('meta[name="description"]').attr('content', description);

      var ogMetaDescription = $('meta[property="og:description"]');
      if (ogMetaDescription.length > 0) {
        ogMetaDescription.attr('content', description);
      }
    }
  }

  /**
  @param {string} updates canonical url path

  This checks if the meta link exists and updates it or creates a new link and appends it to the head of the document. 
  */
  updateCanoncial(canonicalUrl) {
    if (canonicalUrl !== undefined && canonicalUrl !== '' && typeof canonicalUrl === 'string') {
      var canoncialLink = $('link[rel="canonical"]');

      if (canoncialLink.length > 0) {
        canoncialLink.attr('href', canonicalUrl);
      } else {
        $('head').append(`<link rel="canonical" href="${ canonicalUrl }" />`);
      }
    }
  }

  /**
  You will overwrite this

  key idea: pass in your data to your template for initial load
  */
  render(data) {
    return `
      <h1 id="title">${ (data && data.title) ? data.title : "" }</h1>
      <div id="content">
        ${ (data && data.content) ? data.content : "" }
      </div>
    `;
  }
}

export default ViewConstructor;


// WEBPACK FOOTER //
// ./src/scripts/site/components/ViewConstructor.js